import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table          : 'CI_RPROPERTY',
    fieldMap       : {
        id                    : 'CIRP_ID',
        key                   : 'CIRP_KEY',
        value                 : 'CIRP_VALUE',
        referenceId           : 'CIRP_CIR_ID',
        referencePropertySetId: 'CIRP_CIRPS_ID',
        statusId              : 'CIRP_CIST_ID',
        modifierUserId        : 'CIRP_MODIFIER',
        modificationTime      : 'CIRP_MODIFICATION_TIME',
        validatorUserId       : 'CIRP_VALIDATOR',
        validationTime        : 'CIRP_VALIDATION_TIME'
    },
    historyFieldMap: {
        id                    : 'CIRP_ID',
        key                   : 'CIRP_KEY',
        value                 : 'CIRP_VALUE',
        referenceId           : 'CIRP_CIR_ID',
        referencePropertySetId: 'CIRP_CIRPS_ID',
        statusId              : 'CIRP_CIST_ID',
        modifierUserId        : 'CIRP_MODIFIER',
        validFromTime         : 'CIRP_VALID_FROM',
        validToTime           : 'CIRP_VALID_TO'
    },
    fieldTypesMap  : {
        id                    : 'INTEGER',
        key                   : 'STRING',
        value                 : 'STRING',
        referenceId           : 'INTEGER',
        referencePropertySetId: 'INTEGER',
        statusId              : 'INTEGER',
        modifierUserId        : 'STRING',
        modificationTime      : 'TIMESTAMP',
        validatorUserId       : 'STRING',
        validationTime        : 'TIMESTAMP',
        validFromTime         : 'TIMESTAMP',
        validToTime           : 'TIMESTAMP'
    }
};

export default tableDefinition;
